import React from "react";

const Step2SaddleStyle = () => {
  return (
    <div className="w-full">
      <h3 className="text-base sm:text-lg lg:text-xl font-bold text-[#2b364b] mb-4 sm:mb-6 text-center font-montserrat">
        Select Saddle Style
      </h3>

      <div className="max-w-md mx-auto">
        <div className="relative w-full">
          <div className="w-full h-[51.8px] border border-[#999] rounded-full flex items-center px-4 bg-gray-50">
            <span className="text-[#2b364b] font-montserrat text-sm pt-2">
              Western
            </span>
          </div>
          <label className="absolute -top-2.5 left-4 bg-white px-1 text-xs text-[#666] font-montserrat">
            Saddle Type
          </label>
        </div>

        <p className="text-xs sm:text-sm text-gray-600 mt-3 sm:mt-4 text-center font-montserrat">
          Currently, only Western saddles are supported.
        </p>
      </div>
    </div>
  );
};

export default Step2SaddleStyle;
